import { ObservableProp, useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';

import container from '~ioc/ioc';
import AuthStore from '~stores/authentication';
import toastStore from '~stores/toast';

@injectable()
class PasswordResetModalPresenter {
  @inject(AuthStore) private _authStore!: AuthStore;

  requestPasswordReset = async (email: string) => {
    try {
      await this._authStore.requestPasswordReset(email);
    } catch (error) {
      toastStore.addMessage({
        message: 'Error requesting a password reset',
        type: 'error',
      });
      throw error;
    }
  };

  visible = new ObservableProp(false);

  show = () => {
    this.visible.set(true);
  };

  hide = () => {
    this.visible.set(false);
  };
}

export const usePasswordResetModalPresenter = () =>
  useClassStore<PasswordResetModalPresenter>(
    container.get(PasswordResetModalPresenter)
  );
